export const FeeFilterVariables = { filters: 'FeeFilters!' };
